import React from "react";
import { BaseIcon, BaseIconProps } from "./baseIcon";

export const CloseRoundFillIcon = React.forwardRef<
  SVGSVGElement,
  BaseIconProps
>((props, ref) => {
  const { opacity = 0.54, ...rest } = props;
  return (
    <BaseIcon ref={ref} {...rest} viewBox="0 0 28 28">
      <path
        d="M13.9987 2.27881C7.55546 2.27881 2.33206 7.50198 2.33206 13.9455C2.33206 20.389 7.55546 25.6121 13.9987 25.6121C20.4422 25.6121 25.6654 20.389 25.6654 13.9455C25.6654 7.50198 20.4422 2.27881 13.9987 2.27881ZM10.4987 9.27881C10.7972 9.27881 11.1095 9.37915 11.3373 9.60665L13.9987 12.2678L16.6599 9.60665C16.8886 9.37915 17.2001 9.27881 17.4987 9.27881C17.7974 9.27881 18.1089 9.37915 18.3376 9.60665C18.7926 10.0628 18.7926 10.8281 18.3376 11.2843L15.6764 13.9455L18.3376 16.6066C18.7926 17.0628 18.7926 17.8281 18.3376 18.2843C17.8814 18.7393 17.1161 18.7393 16.6599 18.2843L13.9987 15.6231L11.3373 18.2843C10.8817 18.7393 10.1158 18.7393 9.66012 18.2843C9.20454 17.8281 9.20454 17.0628 9.66012 16.6066L12.3211 13.9455L9.66012 11.2843C9.20454 10.8281 9.20454 10.0628 9.66012 9.60665C9.88809 9.37915 10.2002 9.27881 10.4987 9.27881Z"
        fill="currentcolor"
        fillOpacity={opacity}
      />
    </BaseIcon>
  );
});

CloseRoundFillIcon.displayName = "CloseRoundFillIcon";
